import { useQuery } from 'react-query';
import getQuality from 'data/requests/getQuality';
import { Quality } from 'model/quality';

const useQuality = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<Quality>(
    ['quality', brandId],
    () => getQuality(brandId),
    {
      enabled: false,
    },
  );

  return { quality: data, isLoading, refetch };
};

export default useQuality;
